/**
 * Apply Spark 0.1's XR rendering settings while an immersive session is active.
 * Sorting retains splats around the viewer so a head turn can reveal them
 * immediately, even while the next asynchronous sort is still running.
 * Head tracking, rendering, and Spark's update scheduling remain unchanged.
 */
export function installSplatXrProfile(renderer, spark) {
  const xr = renderer.xr
  const view = spark.defaultView
  let desktopSettings = null
  let disposed = false

  const enterXr = () => {
    if (disposed || desktopSettings !== null) return
    desktopSettings = {
      maxStdDev: spark.maxStdDev,
      sortRadial: view.sortRadial,
      sort360: view.sort360,
    }
    spark.maxStdDev = Math.sqrt(5)
    view.sortRadial = true
    view.sort360 = true
    // Changing sort360 alone does not invalidate Spark's existing draw list.
    // Rebuild it on the next normal update, including for paused scenes.
    spark.needsUpdate = true
  }

  const leaveXr = () => {
    if (desktopSettings === null) return
    spark.maxStdDev = desktopSettings.maxStdDev
    view.sortRadial = desktopSettings.sortRadial
    view.sort360 = desktopSettings.sort360
    desktopSettings = null
    spark.needsUpdate = true
  }

  xr.addEventListener('sessionstart', enterXr)
  xr.addEventListener('sessionend', leaveXr)
  if (xr.isPresenting) enterXr()

  return () => {
    if (disposed) return
    disposed = true
    xr.removeEventListener('sessionstart', enterXr)
    xr.removeEventListener('sessionend', leaveXr)
    leaveXr()
  }
}
